import React from 'react';
import PropTypes from 'prop-types';

function ProgressCardItem({ value, title }) {
    return (
        <div className="progress-card__item">
            <h2 className="progress-card__item-value">{value}</h2>
            <div className="progress-card__item-title">{title}</div>
        </div>
    );
}

function ProgressOverviewCard({ data, className }) {

    return (
        <div className={`progress-card ${className}`}>
            {data.map((item, index) => (
                <>
                    <ProgressCardItem value={item.value} title={item.label} />
                    {index < data.length - 1 && <div className="progress-card__line" />}
                </>
            ))}
        </div>
    )
}

ProgressOverviewCard.propTypes = {
    data: PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string,
    }).isRequired,
    className: PropTypes.string,
};

ProgressOverviewCard.defaultProps = {
    className: '',
};

export default ProgressOverviewCard;
